var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockedWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.1221C17 21.4331 17 20.5886 17.2336 19.9085C17.6651 18.6521 18.6521 17.6651 19.9085 17.2336C20.5886 17 21.4331 17 23.1221 17H24C25.354 17 26.0311 17 26.593 17.1177C28.7477 17.5689 30.4311 19.2523 30.8823 21.407C31 21.9689 31 22.646 31 24C31 25.354 31 26.0311 30.8823 26.593C30.4311 28.7477 28.7477 30.4311 26.593 30.8823C26.0311 31 25.354 31 24 31C22.646 31 21.9689 31 21.407 30.8823C19.2523 30.4311 17.5689 28.7477 17.1177 26.593C17 26.0311 17 25.354 17 24V23.1221Z",
    fill: "#E5B910"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5871,
    cy: 22.3877,
    r: 1.97968,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1594 11.8372C35.6923 11.386 34.9751 11.3887 34.5252 11.8386L13.0879 33.2732C12.6367 33.7244 12.6367 34.4429 13.0919 34.9152C13.3248 35.1309 13.6133 35.25 13.9057 35.25C14.2048 35.25 14.5118 35.1243 14.7248 34.9113L36.1607 13.4766C36.6133 13.0241 36.6133 12.2911 36.1594 11.8372Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedWithBg);
export default __webpack_public_path__ + "static/media/blocked-with-bg.e8a268f6e28610a5633dd141501ac788.svg";
export { ForwardRef as ReactComponent };